import type { LandingVariant } from '../types/landing'

export const landingVariants: LandingVariant[] = [
  {
    slug: 'bay-area',
    pageTitle: 'Twenty Mile House — Bay Area',
    eyebrow: 'Bay Area Brides',
    headline: [
      { text: 'Experience a California wedding everyone you love will ' },
      { text: 'never forget', emphasis: 'underline' },
      { text: '. ' },
      { text: 'Every detail done for you.', emphasis: 'underline' },
    ],
    intro:
      'To take the stress out of planning your wedding, we handle all the vendors: photography, florals, DJ/MC, catering, full-service bar, event staffing, cake and dessert. Just bring your officiant and beverages!',
    highlights: [
      'One contact instead of eleven vendors',
      'Photography, florals, DJ and cake booked for you',
      'Farm-to-table catering and a full bar',
      'Your own coordinator from tour to send-off',
      'The whole estate, never shared with another wedding',
    ],
    stats: [
      { value: '200', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '1 hr', label: 'From Reno-Tahoe airport' },
      { value: '3 days', label: 'On the property' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
  {
    slug: 'northern-california',
    pageTitle: 'Twenty Mile House — Sacramento & Northern California',
    eyebrow: 'For Sacramento, Roseville, Folsom, Chico and Reno couples',
    headline: [
      { text: 'For couples planning a Northern California wedding: a cheaper venue still leaves ' },
      { text: 'eight vendors for you to hire', emphasis: 'strong' },
      { text: '.' },
    ],
    intro:
      'Our packages bring in trusted local vendors who have run weddings here for years, your own coordinator, and reserved on-site accommodation. One package, no hidden fees — we handle the planning so your day is unforgettable.',
    highlights: [
      'Photography, florals, DJ and cake included',
      'Farm-to-table catering and a full bar',
      'Your own coordinator, not a day-of stranger',
      'Lodging reserved on site for 54 people, priced separately',
      'Sunday to Thursday and shoulder season dates open',
    ],
    stats: [
      { value: '200', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '1 hr', label: 'From Reno' },
      { value: '2.5 hrs', label: 'From Sacramento' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
  {
    slug: 'out-of-state',
    pageTitle: 'Twenty Mile House — Destination Weddings',
    eyebrow:
      'For couples planning a Northern California wedding from Seattle, Denver, LA, Austin or New York',
    headline: [
      { text: 'Most venues give you ' },
      { text: '9 hours', emphasis: 'strong' },
      { text: '. We give you full access to our 200-acre property for a ' },
      { text: 'wedding weekend', emphasis: 'strong' },
      { text: '.' },
    ],
    intro:
      'No shuttling guests between a ceremony site and a reception hall. No coordinating a dozen separate vendors. A typical weekend: your guests check in Friday and leave Sunday, everyone in one place on 200 acres. The logistics and your questions get answered on your virtual tour, before you commit.',
    highlights: [
      'Planned remotely through one coordinator',
      'Photography, florals, DJ, catering and bar',
      'On-site lodging for your whole party',
      'Everyone in one place for three nights',
      'Virtual tour of every inch before you commit',
    ],
    stats: [
      { value: '200', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '1 hr', label: 'From Reno-Tahoe airport' },
      { value: '72 hrs', label: 'One place, no shuttles' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
]
